import { Reducer } from 'redux';
import { CampaignsActionTypes } from '@/store/campaigns/types';
import { sortBy } from 'lodash-es';
import { CampaignsInterface } from '../types';

export const SimpleStatsAllDataInitialState: CampaignsInterface = {
    loading: null,
    abSplitHeaderControls: null,
    pickedContactEmail: null,
    simpleStatsAllData: null,
};

const reducer: Reducer<CampaignsInterface> = (
    state: CampaignsInterface = SimpleStatsAllDataInitialState,
    action
): CampaignsInterface => {
    switch (action.type) {
        case CampaignsActionTypes.GET_CAMPAIGN_SIMPLE_STATS_ALL_DATA_SUCCESS:
            return {
                ...state,
                simpleStatsAllData: {
                    CampaignTemplatesSummary: sortBy(action.payload.CampaignTemplatesSummary, (a): number =>
                        a.IsWinner ? 1 : 0
                    ),
                },
            };
        default:
            return state;
    }
};

export { reducer as simpleStatsAllData };

export default reducer;
